module.exports = __webpack_public_path__ + "img/IMG_2393.040ef030.jpg";